import { useState, useEffect } from 'react';
import { useCliente } from '../hooks/useCliente';
import { useClient } from '../hooks/useClient';
import './clientes.css';

export const Clientes = ({ cerrarModal, onClienteSeleccionado }) => {
  const [filter, setFilter] = useState('');
  const [cliente, setCliente] = useState(null);
  const { fetchClientes, filteredClientes } = useCliente();
  const { setQueryData: setQueryDataClient } = useClient();

  useEffect(() => {
    if (filter !== '') {
      fetchClientes(filter);
    }
  }, [filter, fetchClientes]);

  const handleSearchInputChange = (e) => {
    setFilter(e.target.value.toUpperCase());
  };

  const handleSuggestionClick = (cliente) => {
    setFilter(cliente.denominacion);
    setCliente(cliente);
  };

  const handleAcceptClick = () => {
    if (onClienteSeleccionado) {
      onClienteSeleccionado(cliente.id); // Para NuevosUsuarios
    } else {
      setQueryDataClient(cliente); // Comportamiento original
    }
    cerrarModal();
  };

  return (
    <div className="contenedorClieyBusc">
      <input
        type="text"
        id="buscarClientes"
        className="buscarClientes"
        placeholder="Buscar..."
        value={filter}
        onChange={handleSearchInputChange}
      />
      {filter !== '' && filteredClientes.length > 0 && (
        <ul className="sugerencias">
          {filteredClientes.map((cliente) => (
            <li
              className="renglonSugerencias"
              key={cliente.id}
              onClick={() => handleSuggestionClick(cliente)}
            >
              {cliente.denominacion}
            </li>
          ))}
        </ul>
      )}

      <button
        className="btnAceptar"
        onClick={handleAcceptClick}
        type="button"
        disabled={!cliente}
      >
        Aceptar
      </button>
    </div>
  );
};
